/* © 2026 Seery-Us Visionz. All rights reserved.
   SV Collection Shop: quick-add popup for design kits, theme chips, size price switch, mix-50 bulk bar. */
(function () {
  if (window.SvCollectionShop) return;
  window.SvCollectionShop = true;

  function boot() {
    var root = document.querySelector('.sv-cs');
    if (!root) return;

    var norm = function (s) { return String(s == null ? '' : s).trim().toLowerCase(); };
    var esc = function (s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); };
    var money = function (c) { return '$' + (Number(c || 0) / 100).toFixed(2); };
    var uniq = function (a) { var o = []; a.forEach(function (x) { if (o.indexOf(x) < 0) o.push(x); }); return o; };
    var isShaker = function (f) { return norm(f).indexOf('shaker') === 0; };
    var hasUv = function (f) { return norm(f).indexOf('uv dtf') >= 0; };
    var store = {
      get: function (k) { try { return localStorage.getItem(k); } catch (e) { return null; } },
      set: function (k, v) { try { if (v == null) localStorage.removeItem(k); else localStorage.setItem(k, v); } catch (e) {} }
    };
    var collectionUrl = root.getAttribute('data-collection-url') || location.pathname;
    var kitType = norm(root.getAttribute('data-kit-type'));
    var bulkGoal = parseInt(root.getAttribute('data-bulk-goal'), 10) || 50;
    var askThick = root.getAttribute('data-thick') === 'true';
    var THICK = ['Regular 1/8"', 'Thin 1/16"'];
    var DOTS = { clear: 'background:repeating-conic-gradient(#e5e7eb 0 25%,#fff 0 50%) 0 0/8px 8px', white: 'background:#fff', black: 'background:#111' };
    var FIN_LABEL = function (f) {
      var n = norm(f);
      if (n === 'acrylic only') return 'Acrylic only';
      if (n === 'acrylic & uv dtf') return 'Acrylic + UV DTF decal';
      if (n === 'shaker - acrylic only') return 'Shaker frame, acrylic only';
      if (n === 'shaker - acrylic & uv dtf') return 'Shaker frame + UV DTF decal';
      return f;
    };

    /* ---------- data ---------- */
    var pCache = {};
    function cleanUrl(u) {
      var a = document.createElement('a'); a.href = u;
      var path = a.pathname.replace(/^\/collections\/[^/]+(?=\/products\/)/, '');
      return path;
    }
    function getProduct(url) {
      var u = cleanUrl(url);
      if (!pCache[u]) {
        pCache[u] = fetch(u + '?view=svjson', { credentials: 'same-origin' })
          .then(function (r) { if (!r.ok) throw new Error('http ' + r.status); return r.text(); })
          .then(function (t) { return JSON.parse(t); })
          .catch(function (e) { delete pCache[u]; throw e; });
      }
      return pCache[u];
    }
    var cCache = {};
    function getCollection(query) {
      var q = query || '';
      var url = collectionUrl + '?' + (q ? q + '&' : '') + 'view=svjson';
      if (!cCache[url]) {
        cCache[url] = fetch(url, { credentials: 'same-origin' })
          .then(function (r) { if (!r.ok) throw new Error('http ' + r.status); return r.text(); })
          .then(function (t) { return JSON.parse(t); })
          .catch(function (e) { delete cCache[url]; throw e; });
      }
      return cCache[url];
    }
    function kitInfo(p) {
      if (!p || !p.options) return null;
      if ((p.tags || []).some(function (t) { return norm(t) === 'sheet-builder'; })) return null;
      var names = p.options.map(norm);
      var iS = names.indexOf('size'), iF = names.indexOf('finish');
      var iC = names.findIndex(function (n) { return n === 'color of acrylic' || n === 'color' || n === 'acrylic color'; });
      if (iS < 0 || iF < 0 || iC < 0) return null;
      var fins = uniq(p.variants.map(function (v) { return v.options[iF]; }));
      if (!fins.some(function (f) { return norm(f) === 'acrylic only'; })) return null;
      return { iS: iS, iF: iF, iC: iC };
    }

    /* ---------- bulk bar ---------- */
    var bulkText = root.querySelector('[data-bulk-text]');
    var bulkFill = root.querySelector('[data-bulk-fill]');
    function refreshBulk(cart) {
      if (!bulkText) return;
      var go = function (c) {
        var n = 0;
        (c.items || []).forEach(function (it) { if (norm(it.product_type) === kitType) n += it.quantity; });
        var pct = Math.min(100, Math.round((n / bulkGoal) * 100));
        bulkFill.style.width = pct + '%';
        if (n >= bulkGoal) bulkText.textContent = n + ' kits in your box. Your discount applies at checkout!';
        else if (n === 0) bulkText.textContent = '0 of ' + bulkGoal + ' kits. Mix and match to start counting.';
        else bulkText.textContent = n + ' of ' + bulkGoal + ' kits. ' + (bulkGoal - n) + ' more to go!';
      };
      if (cart) return go(cart);
      fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(go).catch(function () {});
    }
    refreshBulk();

    /* ---------- theme chips ---------- */
    root.querySelectorAll('[data-chip]').forEach(function (a) {
      var u = new URL(location.href);
      var param = a.getAttribute('data-param');
      u.searchParams.delete(param);
      u.searchParams.delete('page');
      // tapping the theme that's already on turns it off and shows the whole list again
      if (!a.classList.contains('is-on')) u.searchParams.set(param, a.getAttribute('data-chip'));
      a.setAttribute('aria-pressed', a.classList.contains('is-on') ? 'true' : 'false');
      if (a.classList.contains('is-on')) a.title = 'Tap again to show all themes';
      var qs = u.searchParams.toString();
      a.href = u.pathname + (qs ? '?' + qs : '');
    });

    /* ---------- size price switch ---------- */
    var curSize = null; // no size is ever picked for the shopper
    var sizeBtns = root.querySelectorAll('[data-size]');
    function markSizes() {
      sizeBtns.forEach(function (b) {
        var on = b.getAttribute('data-size') === curSize;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }
    function priceFor(v, size) {
      var r = { kit: null, blank: null, shaker: null };
      v.forEach(function (x) {
        if (x[0] !== size) return;
        var f = norm(x[1]);
        if (f === 'acrylic & uv dtf') r.kit = r.kit == null ? x[2] : Math.min(r.kit, x[2]);
        else if (f === 'acrylic only') r.blank = r.blank == null ? x[2] : Math.min(r.blank, x[2]);
        else if (f.indexOf('shaker') === 0) r.shaker = r.shaker == null ? x[2] : Math.min(r.shaker, x[2]);
      });
      return r;
    }
    var allSizes = Array.prototype.map.call(sizeBtns, function (b) { return b.getAttribute('data-size'); });
    function applySizes() {
      markSizes();
      var grid = document.getElementById('ProductGridContainer');
      if (!grid) return;
      var cards = grid.querySelectorAll('.card-wrapper');
      if (!curSize) {
        cards.forEach(function (c) { var pe = c.querySelector('.price'); if (pe && pe.__svOrig != null) { pe.innerHTML = pe.__svOrig; pe.__svOrig = null; pe.classList.remove('sv-cs-priced'); } });
        return;
      }
      getCollection(location.search.replace(/^\?/, '').replace(/(^|&)view=[^&]*/, '')).then(function (data) {
        var map = {};
        data.products.forEach(function (p) { map[p.handle] = p; });
        cards.forEach(function (c) {
          var a = c.querySelector('a[href*="/products/"]');
          var pe = c.querySelector('.price');
          if (!a || !pe) return;
          var h = (a.getAttribute('href').split('/products/')[1] || '').split(/[?#/]/)[0];
          var p = map[h];
          if (!p || !p.v || !p.v.length) return;
          if ((p.tags || []).some(function (t) { return norm(t) === 'sheet-builder'; })) return;
          var sizes = uniq(p.v.map(function (x) { return x[0]; }));
          if (!sizes.some(function (s) { return allSizes.indexOf(s) >= 0; })) return; // not a size-based kit
          if (pe.__svOrig == null) pe.__svOrig = pe.innerHTML;
          pe.classList.add('sv-cs-priced');
          var r = priceFor(p.v, curSize);
          var html;
          if (r.kit == null && r.blank == null) {
            html = '<div class="sv-cs-cardprice"><em>Not offered in ' + esc(curSize) + '</em></div>';
          } else {
            html = '<div class="sv-cs-cardprice">' +
              (r.kit != null ? '<b>' + money(r.kit) + ' <small>kit &middot; ' + esc(curSize) + '</small></b>' : '') +
              (r.blank != null ? (r.kit != null ? '<span>Acrylic only ' + money(r.blank) + '</span>' : '<b>' + money(r.blank) + ' <small>acrylic &middot; ' + esc(curSize) + '</small></b>') : '') +
              (r.shaker != null ? '<span>Shaker frame from ' + money(r.shaker) + '</span>' : '') +
              '</div>';
          }
          pe.innerHTML = html;
        });
      }).catch(function () {});
    }
    sizeBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        var s = b.getAttribute('data-size');
        curSize = curSize === s ? null : s;
        applySizes();
      });
    });
    applySizes();
    var gridC = document.getElementById('ProductGridContainer');
    if (gridC && window.MutationObserver) {
      var t;
      new MutationObserver(function () { clearTimeout(t); t = setTimeout(function () { if (curSize) applySizes(); }, 250); })
        .observe(gridC, { childList: true, subtree: false });
    }

    /* ---------- popup ---------- */
    var dlg = root.querySelector('[data-dlg]');
    var vForm = dlg.querySelector('[data-view-form]');
    var vDone = dlg.querySelector('[data-view-done]');
    var fields = dlg.querySelector('[data-fields]');
    var qtyIn = dlg.querySelector('[data-qty]');
    var errEl = dlg.querySelector('[data-err]');
    var addBtn = dlg.querySelector('[data-add]');
    var S = null; // popup state

    /* Which products the popup can handle by itself. Anything with add-on products, uploads,
       text fields, conditional options, trays or the gang sheet app keeps the theme's full quick-add. */
    var SIMPLE_TYPES = { choice: 1, info: 1, heading: 1, divider: 1 };
    function popupMode(p) {
      if (!p || !p.variants || !p.variants.length) return 'native';
      var tags = (p.tags || []).map(norm);
      if (tags.indexOf('sheet-builder') >= 0) return 'page';
      if (tags.indexOf('gang sheet') >= 0) return 'native';
      // 3D prints in color families get the VIP exact-color picker on the product page, so keep the full quick-add
      var fam = /^(random mixed|pinks|purples|blues|yellows|oranges|reds|greens)$/i;
      var famOpt = (p.options || []).some(function (n, i) {
        if (!/^colou?rs?$/i.test(n)) return false;
        return uniq(p.variants.map(function (v) { return v.options[i]; })).filter(function (v) { return fam.test(v); }).length >= 4;
      });
      if (famOpt) return 'native';
      var ok = (p.setOptions || []).every(function (o) {
        if (o.values_from || o.html_from) return false;
        if (!SIMPLE_TYPES[o.type]) return false;
        if (o.show_if || o.audience || o.variant || o.handle) return false;
        if (o.type === 'choice') {
          if (!o.values || !o.values.length) return false;
          if (o.values.some(function (v) { return v.variant || v.handle || v.vip_variant || v.vip_handle; })) return false;
        }
        return true;
      });
      return ok ? 'popup' : 'native';
    }

    var isSizeName = function (n) { return /\bsizes?\b/i.test(n || ''); };
    var isFinishName = function (n) { return /^finish$/i.test((n || '').trim()); };
    var isColorName = function (n) { return /colou?r/i.test(n || ''); };

    function matches(v, sel, skip) {
      return S.opts.every(function (o, i) { return i === skip || sel[i] == null || v.options[i] === sel[i]; });
    }
    function availWith(i, val) {
      return S.p.variants.some(function (v) { return v.available && v.options[i] === val && matches(v, S.sel, i); });
    }
    function existsWith(i, val) {
      return S.p.variants.some(function (v) { return v.options[i] === val && matches(v, S.sel, i); });
    }
    function currentVariant() {
      if (S.sel.some(function (x) { return x == null; })) return null;
      return S.p.variants.find(function (v) { return S.opts.every(function (o, i) { return v.options[i] === S.sel[i]; }); }) || null;
    }
    function shakerPicked() {
      return S.sel.some(function (x) { return x && isShaker(x); });
    }
    function thickShown() {
      return S.thick && !shakerPicked();
    }
    function fixSel() {
      // drop a pick that no longer exists with the others; non-size options fall back to the first that works
      S.opts.forEach(function (o, i) {
        if (S.sel[i] != null && !existsWith(i, S.sel[i])) {
          S.sel[i] = null;
          if (!o.isSize) S.sel[i] = o.values.find(function (v) { return availWith(i, v); }) || null;
        }
      });
    }

    function chips(label, key, values, isOn, labelFn, enabledFn, extra, multi, labelLink) {
      var h = '<div class="sv-cs-field"><span class="sv-cs-flabel">' + esc(label) + (labelLink || '') + '</span><div class="sv-cs-opts" role="' + (multi ? 'group' : 'radiogroup') + '" aria-label="' + esc(label) + '">';
      values.forEach(function (v) {
        var on = isOn(v);
        var en = enabledFn ? enabledFn(v) : true;
        h += '<button type="button" class="sv-cs-opt' + (on ? ' is-on' : '') + '" role="' + (multi ? 'checkbox' : 'radio') + '" aria-checked="' + on + '" data-k="' + esc(key) + '" data-v="' + esc(v) + '"' + (en ? '' : ' disabled') + '>' +
          (extra ? extra(v) : '') + esc(labelFn ? labelFn(v) : v) + '</button>';
      });
      return h + '</div></div>';
    }

    /* ---------- "Compare thicknesses" and "See hole options" pop-ups (same as the product page) ---------- */
    function holePics() {
      var out = [];
      (S.p.setOptions || []).forEach(function (o) {
        if (o.type !== 'info' || !o.html || !/<img/i.test(o.html)) return;
        var d = document.createElement('div'); d.innerHTML = o.html;
        d.querySelectorAll('img').forEach(function (im) { if (im.getAttribute('src')) out.push(im.getAttribute('src')); });
      });
      return out;
    }
    var THICK_INFO = [
      { mm: 3.18, name: 'Regular 1/8"', cmp: '≈ 2 quarters', note: 'Our standard. Still slim, but sturdy. Best for keychains, charms, badge reels & signs.' },
      { mm: 1.59, name: 'Thin 1/16"', cmp: '≈ 1 quarter', note: 'Half as thick. Lighter & a little flexible. Great for layering.' }
    ];
    function thickSvg() {
      // side view of a 2" piece, length and thickness at the SAME scale
      var W = 300, pxmm = W / 50.8, y = 8, parts = '';
      THICK_INFO.forEach(function (r) {
        var h = Math.max(2, r.mm * pxmm), top = y + 16; y = top + h + 22;
        parts += '<text x="0" y="' + (top - 5) + '" font-size="12.5" font-weight="700" fill="#1f2328">' + esc(r.name) +
          '<tspan font-weight="400" font-size="11" fill="#6b7280"> · ' + r.mm.toFixed(1) + ' mm ' + r.cmp + '</tspan></text>' +
          '<rect x="0" y="' + top + '" width="' + W + '" height="' + h.toFixed(1) + '" rx="1" fill="url(#svcsAcr)" stroke="#6fb6cf" stroke-width=".8"/>';
      });
      var qd = 24.26 * pxmm, qh = 1.75 * pxmm, qt = y + 16; y = qt + qh + 10;
      parts += '<text x="0" y="' + (qt - 5) + '" font-size="12.5" font-weight="700" fill="#1f2328">US quarter<tspan font-weight="400" fill="#6b7280"> · for size</tspan></text>' +
        '<rect x="0" y="' + qt + '" width="' + qd.toFixed(1) + '" height="' + qh.toFixed(1) + '" rx="' + (qh / 2).toFixed(1) + '" fill="url(#svcsCoin)" stroke="#8a8f96" stroke-width=".8"/>' +
        '<line x1="0" x2="' + W + '" y1="' + (y + 6) + '" y2="' + (y + 6) + '" stroke="#9ca3af"/><line x1="0" x2="0" y1="' + (y + 2) + '" y2="' + (y + 10) + '" stroke="#9ca3af"/>' +
        '<line x1="' + W + '" x2="' + W + '" y1="' + (y + 2) + '" y2="' + (y + 10) + '" stroke="#9ca3af"/>' +
        '<text x="' + (W / 2) + '" y="' + (y + 22) + '" font-size="11" text-anchor="middle" fill="#6b7280">2" piece, side view</text>';
      return '<svg viewBox="0 -2 ' + W + ' ' + (y + 30) + '" width="100%" role="img" aria-label="Side view of a 2 inch piece in each thickness, drawn to scale next to a US quarter">' +
        '<defs><linearGradient id="svcsAcr" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#e6f6fb"/><stop offset="1" stop-color="#8fcbe0"/></linearGradient>' +
        '<linearGradient id="svcsCoin" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#e3e5e8"/><stop offset="1" stop-color="#a9adb3"/></linearGradient></defs>' + parts + '</svg>';
    }
    var helpDlg = null;
    function showHelp(kind) {
      if (!helpDlg) {
        helpDlg = document.createElement('dialog');
        helpDlg.className = 'sv-cs-helpdlg';
        helpDlg.addEventListener('click', function (e) { if (e.target === helpDlg || e.target.closest('[data-help-close]')) helpDlg.close(); });
        helpDlg.addEventListener('cancel', function (e) { e.stopPropagation(); });
        document.body.appendChild(helpDlg);
      }
      var body;
      if (kind === 'thick') {
        body = '<div class="sv-cs-helphead"><strong>Acrylic thickness, side view</strong><button type="button" class="sv-cs-x2" data-help-close aria-label="Close">&times;</button></div>' +
          '<p class="sv-cs-helpsub">True to scale: a 2″ piece seen from the side, next to a quarter.</p>' + thickSvg() +
          '<ul class="sv-cs-helplist">' + THICK_INFO.map(function (r) { return '<li><strong>' + esc(r.name.replace('"', '″')) + '</strong> – ' + esc(r.note) + '</li>'; }).join('') + '</ul>';
      } else {
        body = '<div class="sv-cs-helphead"><strong>Hole options</strong><button type="button" class="sv-cs-x2" data-help-close aria-label="Close">&times;</button></div>' +
          '<p class="sv-cs-helpsub">Holes are cut in the acrylic only, never the decal. No selection ships with no hole.</p>' +
          '<div class="sv-cs-helpimgs">' + holePics().map(function (src) { return '<img src="' + esc(src) + '" alt="Hole style examples" loading="lazy">'; }).join('') + '</div>';
      }
      helpDlg.innerHTML = '<div class="sv-cs-helpbox">' + body + '<button type="button" class="sv-cs-add" data-help-close>Got it</button>' +
        '<p class="sv-cs-copy">© ' + new Date().getFullYear() + ' Seery-Us Visionz. All rights reserved.</p></div>';
      if (helpDlg.showModal) helpDlg.showModal(); else helpDlg.setAttribute('open', '');
    }

    function render() {
      fixSel();
      var h = '';
      S.opts.forEach(function (o, i) {
        if (S.single) return;
        var vals = o.values.filter(function (v) { return existsWith(i, v); });
        var label = o.isColor && /acrylic/i.test(o.name) ? 'Acrylic color' : o.name;
        h += chips(label, 'o:' + i, vals,
          function (v) { return S.sel[i] === v; },
          o.isFinish ? FIN_LABEL : null,
          function (v) { return availWith(i, v); },
          o.isColor ? function (v) { var d = DOTS[norm(v)]; return d ? '<span class="sv-cs-dot" style="' + d + '"></span>' : ''; } : null);
        // thickness sits right after the finish (or after the last variant option)
        if (thickShown() && (o.isFinish || (i === S.opts.length - 1 && !S.opts.some(function (x) { return x.isFinish; })))) {
          h += chips('Acrylic thickness *', 'thick', THICK, function (t) { return S.thick === t; }, function (t) { return t.replace('"', '″'); }, null, null, false, '<button type="button" class="sv-cs-help" data-help="thick">Compare thicknesses</button>');
        }
      });
      if (S.single && thickShown()) h += chips('Acrylic thickness *', 'thick', THICK, function (t) { return S.thick === t; }, function (t) { return t.replace('"', '″'); }, null, null, false, '<button type="button" class="sv-cs-help" data-help="thick">Compare thicknesses</button>');
      (S.p.setOptions || []).forEach(function (o) {
        if (o.type === 'choice') {
          var multi = !!o.multi && !o.one;
          var cur = S.set[o.label] || [];
          h += chips(o.label + (o.required ? '' : ' (optional)'), 'set:' + o.label, o.values.map(function (v) { return v.label; }),
            function (v) { return cur.indexOf(v) >= 0; }, null, null, null, multi,
            (/\bholes?\b/i.test(o.label) && holePics().length) ? '<button type="button" class="sv-cs-help" data-help="holes">See hole options</button>' : '');
        } else if (o.type === 'info' && o.html && !/<img/i.test(o.html)) {
          if (/uv dtf/i.test(o.html) && !S.sel.some(function (x) { return x && hasUv(x); })) return;
          h += '<div class="sv-cs-field sv-cs-note">' + o.html + '</div>';
        }
      });
      fields.innerHTML = h;
      price();
    }

    function missing() {
      var out = [];
      S.opts.forEach(function (o, i) { if (S.sel[i] == null) out.push(o.isSize ? 'a size' : 'a ' + o.name.toLowerCase()); });
      (S.p.setOptions || []).forEach(function (o) { if (o.type === 'choice' && o.required && !(S.set[o.label] || []).length) out.push('“' + o.label + '”'); });
      return out;
    }

    function price() {
      var q = Math.max(1, parseInt(qtyIn.value, 10) || 1);
      var pe = dlg.querySelector('[data-price]');
      var v = currentVariant();
      if (!v) {
        var pool = S.p.variants.filter(function (x) { return matches(x, S.sel, -1); });
        var low = null;
        pool.forEach(function (x) { if (low == null || x.price < low) low = x.price; });
        var sizeMissing = S.opts.some(function (o, i) { return o.isSize && S.sel[i] == null; });
        pe.innerHTML = (low != null ? '<small>from</small> ' + money(low) + ' ' : '') + '<small>&middot; ' + (sizeMissing ? 'choose a size' : 'choose your options') + '</small>';
        addBtn.disabled = false; addBtn.textContent = 'Put It In My Box';
        return;
      }
      addBtn.disabled = !v.available;
      addBtn.textContent = v.available ? 'Put It In My Box' : 'Sold out';
      pe.innerHTML = money(v.price) + ' <small>each' + (q > 1 ? ' &middot; ' + money(v.price * q) + ' for ' + q : '') + '</small>';
    }

    fields.addEventListener('click', function (e) {
      var hb = e.target.closest('[data-help]');
      if (hb) { e.preventDefault(); showHelp(hb.getAttribute('data-help')); return; }
      var b = e.target.closest('.sv-cs-opt');
      if (!b || b.disabled) return;
      var k = b.getAttribute('data-k'), v = b.getAttribute('data-v');
      if (k.indexOf('o:') === 0) S.sel[Number(k.slice(2))] = v;
      else if (k === 'thick') S.thick = v;
      else if (k.indexOf('set:') === 0) {
        var lbl = k.slice(4);
        var o = (S.p.setOptions || []).find(function (x) { return x.label === lbl; });
        var cur = S.set[lbl] || [];
        if (o && o.multi && !o.one) {
          var at = cur.indexOf(v);
          if (at >= 0) cur.splice(at, 1); else if (!o.max || cur.length < o.max) cur.push(v);
          S.set[lbl] = cur;
        } else {
          // tapping the picked choice again clears it when it's optional
          S.set[lbl] = (cur[0] === v && !(o && o.required)) ? [] : [v];
        }
      }
      errEl.hidden = true;
      render();
    });
    qtyIn.addEventListener('input', price);
    dlg.querySelectorAll('[data-step]').forEach(function (b) {
      b.addEventListener('click', function () { qtyIn.value = Math.max(1, (parseInt(qtyIn.value, 10) || 1) + parseInt(b.getAttribute('data-step'), 10)); price(); });
    });
    dlg.querySelectorAll('[data-preset]').forEach(function (b) {
      b.addEventListener('click', function () { qtyIn.value = b.getAttribute('data-preset'); price(); });
    });
    dlg.querySelectorAll('[data-close]').forEach(function (b) { b.addEventListener('click', function () { dlg.close(); }); });
    dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });

    function open(p) {
      var single = !p.options || !p.options.length || (p.options.length === 1 && /^title$/i.test(p.options[0]) && p.variants.length === 1);
      var opts = single ? [] : p.options.map(function (name, i) {
        return {
          name: name,
          values: uniq(p.variants.map(function (v) { return v.options[i]; })),
          isSize: isSizeName(name), isFinish: isFinishName(name), isColor: isColorName(name)
        };
      });
      S = { p: p, opts: opts, single: single, sel: opts.map(function () { return null; }), set: {}, thick: null };
      // only sizes start empty; other options start on the first one that is in stock
      var pref = { finish: 'Acrylic & UV DTF', color: 'Clear' };
      opts.forEach(function (o, i) {
        if (o.isSize) return;
        var want = o.isFinish ? pref.finish : o.isColor ? pref.color : null;
        var hit = want && o.values.find(function (v) { return norm(v) === norm(want); });
        S.sel[i] = (hit && availWith(i, hit)) ? hit : (o.values.find(function (v) { return availWith(i, v); }) || o.values[0]);
      });
      if (single) S.sel = [];
      // acrylic thickness, the same way the product page asks for it
      var names = p.options || [];
      var hasThickAlready = (p.setOptions || []).some(function (o) { return /thickness/i.test(o.label || ''); }) ||
        opts.some(function (o) { return o.values.some(function (v) { return /1\/(8|16|32)/.test(v); }); });
      // same rules as the product page: acrylic size listings (not shakers/SVG) and every badge buddy / badge topper
      var sizeRule = names.some(isSizeName) && names.some(function (n) { return /acrylic|finish/i.test(n); }) && !/shaker|svg/i.test(p.title || '');
      var badgeRule = /badge (buddy|buddies|topper)/i.test(p.title || '');
      if (askThick && !hasThickAlready && (sizeRule || badgeRule)) {
        S.thick = THICK[0];
      }
      (p.setOptions || []).forEach(function (o) { if (o.type === 'choice') S.set[o.label] = o.default ? [o.default] : []; });
      qtyIn.value = 1;
      errEl.hidden = true;
      vForm.hidden = false; vDone.hidden = true;
      var img = dlg.querySelector('[data-img]');
      if (p.image) { img.src = p.image; img.alt = p.title; img.hidden = false; } else img.hidden = true;
      dlg.querySelector('[data-title]').textContent = p.title;
      dlg.querySelector('[data-link]').href = p.url;
      render();
      if (!dlg.open) { if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', ''); }
      dlg.scrollTop = 0;
    }

    function updateBubble(sections) {
      var html = sections && sections['cart-icon-bubble'];
      var el = document.getElementById('cart-icon-bubble');
      if (!html || !el) return;
      var d = new DOMParser().parseFromString(html, 'text/html');
      var s = d.querySelector('.shopify-section');
      if (s) el.innerHTML = s.innerHTML;
    }

    addBtn.addEventListener('click', function () {
      var miss = missing();
      if (miss.length) {
        errEl.textContent = 'Please choose ' + miss.join(', ') + '.'; errEl.hidden = false;
        var sf = fields.querySelector('.sv-cs-field'); if (sf && sf.scrollIntoView) sf.scrollIntoView({ block: 'center', behavior: 'smooth' });
        return;
      }
      var v = S.single ? S.p.variants[0] : currentVariant();
      if (!v) return;
      var q = Math.max(1, parseInt(qtyIn.value, 10) || 1);
      var props = {};
      if (thickShown()) props['Acrylic Thickness'] = S.thick;
      var anySet = false;
      Object.keys(S.set).forEach(function (k) { if (S.set[k].length) { props[k] = S.set[k].join(', '); anySet = true; } });
      if (S.p.set && anySet) props['_sv_set'] = S.p.set;
      addBtn.disabled = true; addBtn.textContent = 'Putting it in your box…';
      errEl.hidden = true;
      fetch('/cart/add.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: v.id, quantity: q, properties: props }], sections: 'cart-icon-bubble', sections_url: location.pathname })
      }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
        .then(function (j) {
          updateBubble(j.sections);
          refreshBulk();
          done(q, props);
          document.dispatchEvent(new CustomEvent('sv:cart-added', { detail: j }));
        })
        .catch(function (j) {
          errEl.textContent = (j && (j.description || j.message)) || 'Could not put it in your box. Please try again.';
          errEl.hidden = false;
          price();
        });
    });

    function done(q, props) {
      vForm.hidden = true; vDone.hidden = false;
      var bits = [];
      S.opts.forEach(function (o, i) { var x = S.sel[i]; if (x) bits.push(o.isFinish ? FIN_LABEL(x) : x.replace(/"/g, '″')); });
      Object.keys(props).forEach(function (k) { if (k.charAt(0) !== '_') bits.push(String(props[k]).replace(/"/g, '″')); });
      dlg.querySelector('[data-done-title]').textContent = 'It’s in your box!';
      dlg.querySelector('[data-done-sub]').textContent = q + ' × ' + S.p.title + (bits.length ? ' · ' + bits.join(' · ') : '');
      var more = dlg.querySelector('[data-more]');
      more.hidden = true;
      var theme = (S.p.theme || [])[0];
      if (!theme) return;
      var cur = S.p.handle;
      getCollection('filter.p.m.custom.theme=' + encodeURIComponent(theme)).then(function (data) {
        var list = data.products.filter(function (p) { return p.handle !== cur; }).slice(0, 6);
        if (!list.length) return;
        dlg.querySelector('[data-more-title]').textContent = 'More from ' + theme;
        dlg.querySelector('[data-more-grid]').innerHTML = list.map(function (p) {
          return '<div class="sv-cs-mcard">' + (p.image ? '<img src="' + esc(p.image) + '" alt="" loading="lazy">' : '') +
            '<a href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
            '<button type="button" data-quick="' + esc(p.url) + '">Quick add</button></div>';
        }).join('');
        more.hidden = false;
      }).catch(function () {});
    }
    dlg.querySelector('[data-more-grid]').addEventListener('click', function (e) {
      var b = e.target.closest('[data-quick]');
      if (!b) return;
      var url = b.getAttribute('data-quick');
      b.textContent = 'Loading…';
      getProduct(url).then(function (p) {
        if (popupMode(p) === 'popup') open(p); else location.href = p.url || url;
      }).catch(function () { location.href = url; });
    });

    /* intercept "Choose options" on cards in the grid */
    function nativeOpen(btn, url) {
      var opener = btn.closest('modal-opener');
      var modal = opener && document.querySelector(opener.getAttribute('data-modal'));
      if (modal && typeof modal.show === 'function') { btn.__svPass = true; modal.show(btn); }
      else location.href = url;
    }
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('modal-opener .quick-add__submit, modal-opener button[data-product-url]');
      if (!btn || !btn.closest('#ProductGridContainer')) return;
      var url = btn.getAttribute('data-product-url');
      if (!url) return;
      e.preventDefault();
      e.stopPropagation();
      btn.classList.add('sv-cs-loading');
      getProduct(url).then(function (p) {
        btn.classList.remove('sv-cs-loading');
        var m = popupMode(p);
        if (m === 'popup') open(p);
        else if (m === 'page') location.href = p.url;
        else nativeOpen(btn, url);
      }).catch(function () {
        btn.classList.remove('sv-cs-loading');
        nativeOpen(btn, url);
      });
    }, true);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
